import React, { Component } from 'react';
import Modal from '../../helpers/Modal';
import SelectField from '../../forms/SelectField';
import { filter } from 'lodash';
import { toSelectionFormat } from '../../../lib/collection.utils';
import TextArea from '../../forms/TextArea';
import ModalButtons from '../forms/ModalButtons';
import DatepickerUnlimited from '../../forms/DatepickerUnlimited';
import { requireUseUntil } from '../../../selectors/admin/models/lineup';
import { CLEARING_OPTIONS } from '../../../constants/settings';

class PerformancesModal extends Component {
    state = { comments: '', live: '', nonLinear: '', useUntil: 0, copyFor: [] };
    _onInput = (value, name) => {
        this.setState({ [name]: value });
        if (name === 'linearStateId') {
            this.setState({ useUntil: 0 });
        }
    };

    _closeModal = () => {
        this.props.closeModal();
        this.setState({ comments: '', live: '', nonLinear: '', useUntil: 0, copyFor: [] });
    };
    _saveModal = () => {
        this.props.saveModal(this.props.open.partnerId, this.state);
        this.setState({ comments: '', live: '', nonLinear: '', useUntil: 0, copyFor: [] });
    };
    componentDidUpdate(prevprops) {
        if (!prevprops.open && this.props.open) {
            this.setState({
                comments: this.props.open.comments,
                live: this.props.open.live,
                nonLinear: this.props.open.nonLinear,
                useUntil: this.props.open.useUntil,
            });
        }
    }
    render() {
        const { open, getPartnerName, dependencies } = this.props;

        return (
            <Modal className="is-big is-black" open={open} onClose={this._closeModal}>
                <h4 className="ckp-admin-modal-forms-title ckp-ts-h1">{`${getPartnerName(open) || ''} Clearance`}</h4>
                <div className="ckp-admin-grid-row">
                    <div className="ckp-admin-grid-column">
                        <SelectField
                            label="Cleared Live"
                            onChange={this._onInput}
                            name={'live'}
                            items={CLEARING_OPTIONS}
                            value={this.state.live}
                        />
                    </div>
                    <div className="ckp-admin-grid-column">
                        <SelectField
                            label="Cleared Non Linear"
                            onChange={this._onInput}
                            name={'nonLinear'}
                            items={CLEARING_OPTIONS}
                            value={this.state.nonLinear}
                        />
                    </div>
                    <div className="ckp-admin-grid-column">
                        {requireUseUntil(this.state.nonLinear) ? (
                            <DatepickerUnlimited
                                onChange={this._onInput}
                                value={this.state.useUntil}
                                label="Non Linear Use Until"
                                name="useUntil"
                            />
                        ) : null}
                    </div>
                </div>
                <TextArea value={this.state.comments} onChange={this._onInput} name={'comments'} label="Comments" />
                <SelectField
                    multiple={true}
                    value={this.state.copyFor}
                    name={'copyFor'}
                    label="Duplicate for"
                    onChange={this._onInput}
                    items={toSelectionFormat(filter(dependencies.partners, (x) => x.id !== open.partnerId))}
                />

                <ModalButtons
                    confirmLabel="Ok"
                    cancelAction={this._closeModal}
                    confirmAction={this._saveModal}
                    inactive={requireUseUntil(this.state.nonLinear) ? !this.state.useUntil : false}
                />
            </Modal>
        );
    }
}

export default PerformancesModal;



// WEBPACK FOOTER //
// ./src/components/admin/lineup/PerformancesModal.js